import * as yup from 'yup';

export interface FormValues {
  email: string;
}

export const validation = yup.object().shape({
  email: yup
    .string()
    .email('This must be a valid email')
    .required('Please enter the email'),
});
